import React, { Component, Fragment, useState } from 'react';
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import CreatableSelect from 'react-select/creatable';

import {
  Grid,
} from "@material-ui/core";

// type State = {
//   isClearable: boolean,
//   isDisabled: boolean,
//   isLoading: boolean,
//   isRtl: boolean,
//   isSearchable: boolean,
// };

const useStyles = makeStyles((theme) =>
  createStyles({
    formControl: {
      width: "100%",
    },
    gridRoot: {
      flexGrow: 1,
      marginBottom: "20px",
    },
  })
);

export const SingleSelect = (props) => {

  const {
    selectOptions,
    index,
    value,
    handleChange,
  } = props.componentObject

  const parsedArray = selectOptions && selectOptions.map((item, index) => {
    return { value: item.id, label: item.value }
  })

  const [state, setState] = useState({
    isLoading: false,
    options: parsedArray,
    value: undefined,
  })



  // state = {
  //   isLoading: false,
  //   options: defaultOptions,
  //   value: undefined,
  // };
  const createOption = (label) => ({
    id: 3,
    name: label,
    label: label,
    value: label.toLowerCase().replace(/\W/g, ''),
  });
  // const handleChange = (newValue, actionMeta) => {
  //   console.group('Value Changed');
  //   console.log(newValue);
  //   console.log(`action: ${actionMeta.action}`);
  //   console.groupEnd();
  // };
  const handleInputChange = (inputValue, actionMeta) => {
    console.group('Input Changed');
    console.log(inputValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };
  const handleCreate = (inputValue) => {
    setState({ isLoading: true });
    console.group('Option created');
    console.log('Wait a moment...');
    setTimeout(() => {
      const { options } = state;
      const newOption = createOption(inputValue);
      console.log(newOption);
      console.groupEnd();
      setState({
        isLoading: false,
        options: [...options, newOption],
        value: newOption,
      });
    }, 1000);
  };

  return (
    <CreatableSelect
      isMulti
      isClearable
      // onChange={handleChange}
      onChange={(e) => handleChange(value, index)}
      onInputChange={handleInputChange}
      onCreateOption={handleCreate}
      options={state.options}
      value={value}
    />
  );
}

export default function SelectComponent(props) {
  const classes = useStyles();
  const { label, componentType } = props.componentObject;

  return (
    <Grid container className={classes.gridRoot}>
      <Grid xs={12} md={4}>
        {label}
      </Grid>

      <Grid xs={12} md={7}>
        <SingleSelect componentObject={props.componentObject} />
      </Grid>

    </Grid>
  );
};